/**
 * @ Author: DY
 * @ Date: 2022-10-13 12:25:27
 * @ LastEditTime: 2022-10-13 17:01:00
 * @ Description: 
 * @ FilePath: \ConcreteCloud.Mobile\src\assets\js\takeTokenParameters.js
 */
/*
 * @Author: DY
 * @LastEditTime: 2020-06-22 11:37:30
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \JiYun_Mobile\src\assets\js\takeTokenParameters.js
 */ 
export default {
    install(Vue) {
        // eslint-disable-next-line consistent-return
        Vue.prototype.$takeTokenParameters = function (fieldName, token) {
            const info = sessionStorage.getItem('userInfo');
            const userInfo = JSON.parse(decodeURI(info));
            let callbackData = null;
            if (fieldName) {
                if (userInfo[fieldName]) {
                    callbackData = userInfo[fieldName];
                }
            } else {
                callbackData = userInfo;
            }
            return callbackData;
        };
    },
};
